import apiService from '../api/apiService';
import { triggerImageDeletionFromUrl } from './imageAssetCleanup';

export const triggerRecipeImageDeletion = (
  imageUrl: string,
  warningMessage: string
) => triggerImageDeletionFromUrl(imageUrl, warningMessage);

export const clearRecipeImage = async (recipeId: string, imageUrl: string, warningMessage: string) => {
  triggerRecipeImageDeletion(imageUrl, warningMessage);
  await apiService.updateRecipeImage(recipeId, null);
};

